type JsonLdProps = {
	schema: Record<string, unknown>;
};

export function JsonLd({ schema }: JsonLdProps) {
	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
		/>
	);
}
